module.exports = __webpack_public_path__ + "media/images/sectionBg--ranking-731fbcdccac4e06ad9b8724ebc860215.jpg";